// Whether the main pointer is a finger (phones and tablets).
//
// Not for what CSS can do: showing hidden controls or fattening hit areas is
// written with Tailwind's `pointer-coarse:`. This is for places where what is
// drawn changes (a tap that first shows the "…" of an image, then opens it; the
// phone's own date picker instead of the calendar).
import { useSyncExternalStore } from "react";

const COARSE = "(pointer: coarse)";

function subscribe(onChange: () => void) {
  const mq = window.matchMedia?.(COARSE);
  mq?.addEventListener("change", onChange);
  return () => mq?.removeEventListener("change", onChange);
}

function snapshot(): boolean {
  return window.matchMedia?.(COARSE).matches ?? false;
}

/** A device touched with fingers. A touch laptop driven by a mouse is not. */
export function useCoarsePointer(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
